import { ErrorMessage } from "@hookform/error-message";
import { Col, Row } from "antd";
import { AxiosError } from "axios";
import { useState, useCallback, useEffect, useMemo } from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import { useNavigate } from "react-router";
import { OpenAPI } from "../../../api";
import { container } from "../../../di/container";
import { ADMIN_TIMELINE_PATH } from "../../../common/router/RouterConfiguration";
import { RequestStatus } from "../../../@types/requestStatus";
import { observer } from "mobx-react";
import Loader from "../../../common/presentation/Loader";
import { ILoginResponce, IUser } from "../../../api/models/Login";
import { Credential } from "../domain/entities/Credential";
import { FilialViewModal } from "../../fillial/ui/view-models/FilialViewModel";
import useDebounce from "../../../common/hooks/useDebounce";
import { FilialService } from "../../fillial/domain/services/FilialService";
import { LoginViewModal } from "./loginViewModal";

import logo from '../../../assets/Logotype.svg'
import eyeIcon from '../../../assets/icons/eye.svg'
import eyeSlashIcon from '../../../assets/icons/eye-slash.svg'

import './AdminLoginStyles.css';

interface ILogInFormFields {
    email: string,
    password: string,
    remember?: boolean,
}

interface IError {
    message: string;
}

export const LoginModal: React.FC = observer(() => {
    const {
        register,
        handleSubmit,
        setValue, 
        clearErrors,
        formState: {
            errors
        },
    } = useForm<ILogInFormFields>();

    const auth = useMemo(() => new LoginViewModal(), []);

    const [error, setError] = useState('');

    const navigate = useNavigate();

    const onSubmit: SubmitHandler<ILogInFormFields> = useCallback(({ email, password, remember }, event) => {
        event?.preventDefault();
        auth.login({
            email: email,
            password: password,
            remember: remember ?? false
        }).then(() => {
            OpenAPI.TOKEN = `${auth.credential.authToken}`;

            navigate(ADMIN_TIMELINE_PATH);


            // localStorage.setItem('user', JSON.stringify(auth.credential.user));
        });

    }, []);

    const credential = container.get(Credential);

    const filialStor = localStorage.getItem('filial');
    const filialVM = useMemo(() => new FilialViewModal(), []);;
    const filialService = container.get(FilialService);

    const [isLoading, setIsLoading] = useState(false);
    const { data, isEmpty, debounceFetcher } = useDebounce<ILoginResponce>({
        //@ts-ignore
        fetchCallback: () => auth.checkAuth().then(() => {
            navigate(ADMIN_TIMELINE_PATH);
        }), timeout: 1500
    });

    useEffect(() => {
        // setIsLoading(true);

        if (localStorage.getItem('refToken')) {
            debounceFetcher();

            // auth.checkAuth().then(() => {

            //     navigate(ADMIN_TIMELINE_PATH);
            // });
            // .finally(()=>{
            //     setIsLoading(false);
            // });
        }

        if (filialStor) {
            // filialVM.filialData.setCity(JSON.parse(filialStor));
            filialService.setCity(JSON.parse(filialStor));
        }

    }, []);

    const emailRegex = /(.+)@(.+){2,}\.(.+){2,}/;


    const [isEmptyPas, setIsEmptyPas] = useState(true);
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);

    const togglePasswordVisibility = () => {
        setIsPasswordVisible(!isPasswordVisible);
    };


    return (

        <>
            {
                isLoading ?
                    <Loader size={250} color="#4b51ea" />
                    :
                    // sm={24} md={20} xl={16}
                    <Col xs={23} sm={17} md={13} lg={11} xl={8} xxl={7} className='modalBg'>
                        <img className='modalLogo' src={logo} alt="logo" />
                        <h2 className="loginTitle">Авторизация</h2>
                        <h3>Войдите в аккаунт со своими данными</h3>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <span>
                                {auth.errorText && <p className='error-message'>{auth.errorText}</p>}
                            </span>
                            <span>
                                <ErrorMessage
                                    errors={errors}
                                    name="email"
                                    render={({ message }) => <span className='error-message'>{message}</span>}
                                />
                            </span>

                            <Row justify="space-evenly" gutter={[0, 16]}>
                                <Col span={24} className="form-group form-group-default" id="emailGroup">
                                    <input
                                        type='email'
                                        placeholder="Введите эл. почту"
                                        className="form-control-login"
                                        {...register("email", {
                                            required: {
                                                value: true,
                                                message: 'Введите эл. почту'
                                            },
                                            pattern: {
                                                value: emailRegex,
                                                message: 'Некорректный адрес эл. почты'
                                            }
                                        })}
                                    />
                                </Col>

                                <Col span={24}>
                                    <span>
                                        <ErrorMessage
                                            errors={errors}
                                            name="password"
                                            render={({ message }) => <span className='error-message'>{message}</span>}
                                        />
                                    </span>
                                    <Col span={24} className="form-group form-group-default" id="passwordGroup" style={{ position: "relative", width: '100%' }}>
                                        <input
                                            type={isPasswordVisible ? "text" : "password"}
                                            placeholder="Введите пароль"
                                            className="form-control-login"
                                            {...register("password", {
                                                required: {
                                                    value: true,
                                                    message: 'Введите пароль'
                                                },
                                            })}
                                            // onChange={onChange}
                                            onChange={(e) => {
                                                setIsEmptyPas(!e.target.value); 
                                                setValue("password", e.target.value); 
                                                clearErrors("password");
                                            }}
                                        />
                                        {
                                            !isEmptyPas ?
                                                <span
                                                    className="password-toggle-icon"
                                                    style={{
                                                        position: "absolute",
                                                        right: "20px",
                                                        top: "50%",
                                                        transform: "translateY(-50%)",
                                                        cursor: "pointer",
                                                    }}
                                                    onClick={togglePasswordVisibility}
                                                >
                                                    {isPasswordVisible ? <img src={eyeIcon} alt='eye' /> : <img src={eyeSlashIcon} alt='eyeSlash' />}
                                                </span>
                                                : null
                                        }
                                        {/* <input
                                            type="password"
                                            placeholder="Введите пароль"
                                            className="form-control-login"
                                            {...register("password", {
                                                required: {
                                                    value: true,
                                                    message: 'Введите пароль'
                                                },
                                            })}
                                        /> */}
                                    </Col>
                                </Col>

                                <Col span={24}>
                                    <label className="form-group remember-me-group" id="rememberMeGroup">
                                        <div className="controls">
                                            <input
                                                type="checkbox"
                                                {...register("remember")}
                                                value={1}
                                                defaultChecked
                                            />
                                            <span className="remember-me-text">Запомнить меня</span>
                                        </div>
                                    </label>
                                </Col>

                                <Col span={24}>
                                    <button
                                        type="submit"
                                        className="btn-block login-button signin"
                                        style={{ padding: 0 }}
                                    // value={'Вход'}
                                    >
                                        {
                                            auth.loginStatus === RequestStatus.LOADING ?
                                                <Loader size={32} />
                                                : 'Вход'
                                        }
                                    </button>
                                </Col>
                            </Row>
                        </form>
                    </Col>
            }
        </>
    );
});

